import { render, staticRenderFns } from "./MvpBulkOrders.vue?vue&type=template&id=122ea166&scoped=true"
import script from "./MvpBulkOrders.vue?vue&type=script&lang=js"
export * from "./MvpBulkOrders.vue?vue&type=script&lang=js"
import style0 from "./MvpBulkOrders.vue?vue&type=style&index=0&id=122ea166&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ea166",
  null
  
)

export default component.exports